import TimeSheetTabContent from './TimeSheetTabContent';

const CheckedContent = () => (
  <TimeSheetTabContent status="2" emptyStateType="time_sheet_checked" showStatusColumn />
);

export default CheckedContent;
